<template>
  <div>


    <weight-line-graph
      class="insetGraph"
      v-if="$store.state.user.scope && activeTab === 'weight'"
      :userId="$store.state.user.scope.user_id"
    ></weight-line-graph>
    <waist-hip-line-graph
      class="insetGraph"
      v-if="$store.state.user.scope && activeTab === 'waist-hip'"
      :userId="$store.state.user.scope.user_id"
    ></waist-hip-line-graph>

    <mu-row gutter v-if="$store.state.user.scope" class="content">
      <mu-col desktop="30" tablet="50">
        <weight-input
          class="card-spacing bottom"
          v-if="$store.state.user.settings"
          style="margin-top: 24px"
          :height="$store.state.user.settings.height"
          :weight="$store.state.user.settings.weight"
          :waist="$store.state.user.settings.waist"
        ></weight-input>

        <tracking-exporter
          type="weight"
        ></tracking-exporter>

        <tracking-notifier
          :userId="$store.state.user.scope.user_id"
        ></tracking-notifier>
      </mu-col>
      <mu-col desktop="70" tablet="50">
        <mu-card
          style="margin-top: 24px;"
          id="blood-glucose-data"
          class="tracking-data"
        >
          <mu-tabs class="weight-tabs" :value="activeTab" @change="handleTabChange">
            <mu-tab class="tabTitle" value="weight" title="WEIGHT"/>
            <mu-tab class="tabTitle" value="waist-hip" title="WAIST-HIP"/>
          </mu-tabs>
          <mu-card-text>
            <p class="tracking-subtext" v-text="$t('message.trackingHelpText')"></p>
          </mu-card-text>
          <div v-if="activeTab === 'weight'">
            <mu-timeline>
              <div v-for="group, groupKey in groupFilter(activeTab)" :key="'group-filter-' + groupKey"
                   style="margin-bottom: 16px;">
                <div v-for="titleItem, titleIndex in group" :key="'group-inner-' + titleIndex" v-if="titleIndex === 0"
                     class="timelineSpacing">
                  <div class="bold timelineTitle groupedDate"
                       v-text="groupedDateFormat(titleItem.date_created)">
                  </div>
                </div>
                <div v-for="item, index in group" :key="'group-item-' + index" class="timelineSpacing"
                     v-bind:class="{notEditMode: !item.isEditMode}">
                  <mu-timeline-item
                    @click.native="showItemControls(item)"
                  >
                    <mu-icon
                      style="margin-left: -4px;"
                      :value="determineIcon(item)"
                      v-bind:class="decideWhetherLostOrGained(item)"
                      slot="icon"
                    />

                    <div v-if="item.image">
                      <img width="50%" v-if="item.image" :src="item.image"/>
                    </div>

                    <div v-if="!item.isEditMode" v-bind:class="{spacingBottom: item.isControlsVisible}">
                      <mu-row>
                        <mu-col>
                          <div class="trackingDate" v-if="!item.isEditMode"
                               v-text="groupedItemDate(item.date_created)"></div>
                        </mu-col>
                        <mu-col>


                          <div v-if="!item.isEditMode" class="reading">


                            <div v-if="$store.state.user.settings.weight.measure === 'kg'">
                               <span v-if="item.userDevice.userDeviceId !== 0">
                           <img style="position:relative;top: 2px;margin-right: 8px;"
                                v-tooltip.left="'From device: ' +  item.userDevice.nickname" width="18"
                                :src="item.userDevice.device.iconBlue"/>
                          </span>
                              <span v-text="item.kg + ' kg' "></span>
                            </div>
                            <div v-if="$store.state.user.settings.weight.measure === 'lbs'">
                               <span v-if="item.userDevice && item.userDevice.userDeviceId !== 0">
                           <img style="position:relative;top: 2px;margin-right: 8px;"
                                v-tooltip.left="'From device: ' +  item.userDevice.nickname" width="18"
                                :src="item.userDevice.device.iconBlue"/>
                          </span>
                              <span v-text="item.lbs + ' lbs'"></span>
                            </div>
                            <div v-if="$store.state.user.settings.weight.measure ==='st-lbs'">

                               <span v-if="item.userDevice.userDeviceId !== 0">
                           <img style="position:relative;top: 2px;margin-right: 8px;"
                                v-tooltip.left="'From device: ' +  item.userDevice.nickname" width="18"
                                :src="item.userDevice.device.iconBlue"/>
                          </span>

                              <span v-text="item.stones + 'st ' + item.pounds + ' lbs'"></span>
                            </div>
                          </div>
                        </mu-col>
                      </mu-row>
                    </div>



                    <div v-if="item.isControlsVisible === true && !item.isEditMode">
                      <mu-flat-button
                        :color="btnColor"
                        :label="$t('message.editText')"
                        icon="edit"
                        @click.native="editReading(item)"
                      >
                      </mu-flat-button>
                      <mu-flat-button
                        :color="btnColor"
                        :label="$t('message.deleteText')"
                        icon="delete"
                        @click.native="deleteReading(item)"
                      ></mu-flat-button>
                    </div>
                    <div v-if="item.isEditMode">
                      <weight-edit
                        @updateReading="updateReading"
                        @closeEditPanel="closeEditMode(item)"
                        :preference="$store.state.user.settings.weight.measure"
                        :item="item"
                      ></weight-edit>
                    </div>
                  </mu-timeline-item>
                </div>
              </div>
            </mu-timeline>
            <mu-card-text align=" center" v-if="isReadingsLoading">
              <mu-circular-progress color="#0179d5"></mu-circular-progress>
              <div>One sec...</div>
            </mu-card-text>
            <div v-if="!isReadingsLoading" ref="detector"></div>
          </div>
          <div v-if="activeTab === 'waist-hip'">
            <mu-timeline v-if="!isReadingsLoading">
              <div v-for="group, groupKey in groupFilter(activeTab)" :key="'group-filter-' + groupKey"
                   style="margin-bottom: 16px;">
                <div v-for="titleItem, titleIndex in group" :key="'group-inner-' + titleIndex" v-if="titleIndex === 0"
                     class="timelineSpacing">
                  <div class="bold timelineTitle groupedDate"
                       v-text="groupedDateFormat(titleItem.date_created)">
                  </div>
                </div>
                <div v-for="item, index in group" :key="'group-item-' + index" class="timelineSpacing"
                     v-bind:class="{notEditMode: !item.isEditMode}">
                  <mu-timeline-item
                    @click.native="showItemControlsWaistHip(item)"
                  >
                    <mu-icon
                      style="margin-left: -4px;"
                      :value="determineIcon(item)"
                      v-bind:class="determineLostOrGainedWaistHip(item)"
                      slot="icon"
                    />

                    <div v-if="item.image">
                      <img width="50%" v-if="item.image" :src="item.image"/>
                    </div>

                    <div v-if="!item.isEditMode" v-bind:class="{spacingBottom: item.isControlsVisible}">
                      <mu-row>
                        <mu-col>
                          <div class="trackingDate" v-if="!item.isEditMode"
                               v-text="groupedItemDate(item.date_created)"></div>
                        </mu-col>
                        <mu-col>
                          <div v-if="!item.isEditMode" class="reading"  style="text-align:right;">
                            <div v-if="$store.state.user.settings.waist.measure === 'cm'">
                              <span v-if="typeof(item.ratio_cm) === 'number'" v-text="item.ratio_cm.toFixed(2)"></span>
                              <span style="display:block;" v-text="'(' + item.waist_cm + 'cm/' + item.hip_cm + 'cm)'"></span>
                            </div>
                            <div v-if="$store.state.user.settings.waist.measure === 'in'">
                              <span v-if="typeof(item.ratio_in) === 'number'" v-text="item.ratio_in.toFixed(2)"></span>
                              <span style="display:block;" v-text="'(' + item.waist_in + 'in/' + item.hip_in + 'in)'"></span>
                            </div>
                          </div>
                        </mu-col>
                      </mu-row>
                    </div>
                    <div v-if="item.isControlsVisible === true && !item.isEditMode">
                      <mu-flat-button
                        :color="btnColor"
                        :label="$t('message.editText')"
                        icon="edit"
                        @click.native="editReadingWaistHip(item)"
                      >
                      </mu-flat-button>
                      <mu-flat-button
                        :color="btnColor"
                        :label="$t('message.deleteText')"
                        icon="delete"
                        @click.native="deleteWaistHipReading(item)"
                      ></mu-flat-button>
                    </div>
                    <div v-if="item.isEditMode">
                      <waist-hip-edit
                        @updateReading="updateWaistHipReading"
                        @closeEditPanel="closeEditModeWaistHip(item)"
                        :preference="$store.state.user.settings.waist.measure"
                        :item="item"
                      ></waist-hip-edit>
                    </div>
                  </mu-timeline-item>
                </div>
              </div>
            </mu-timeline>
            <mu-card-text align=" center" v-if="isReadingsLoading">
              <mu-circular-progress color="#0179d5"></mu-circular-progress>
              <div>One sec...</div>
            </mu-card-text>
            <div v-if="!isReadingsLoading" ref="detector"></div>
          </div>
        </mu-card>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>

  import WeightApi from '../../api/Tracking/Weight'
  import TrackingDetailMixin from "../../mixins/TrackingDetailMixin"
  import WeightLineGraph from "../../components/Tracking/Graphs/Weight/LineGraph";
  import WaistHipLineGraph from "../../components/Tracking/Graphs/Waist/LineGraph"
  import WeightInput from "../../components/Tracking/Input/Weight/Weight";
  import WeightEdit from "../../components/Tracking/Edit/Weight/WeightEdit";
  import WaistHipEdit from "../../components/Tracking/Edit/WaistHip/WaistHipEdit";

  let fromDate = moment().subtract(1, 'month');
  let toDate = moment();

  import {directive as onClickaway} from 'vue-clickaway';
  import TrackingNotifier from "../../components/TrackingNotifier/TrackingNotifier";
  import TrackingExporter from "../../components/Tracking/Exporter/Exporter.vue";

  export default {
    mixins: [TrackingDetailMixin],

    components: {
      TrackingExporter,
      TrackingNotifier,
      WeightEdit,
      WaistHipEdit,
      WeightInput,
      WeightLineGraph,
      WaistHipLineGraph
    },
    data: function () {
      return {
        btnColor: '#1692DA',
        activeTab: 'weight',
      }
    },
    directives: {
      onClickaway: onClickaway,
    },
    mounted: function () {
      let self = this;
      self.loadData();
      self.$gtag.pageview('/tracking/weight');

      self.$EventBus.$on('weightPusherReceived', function () {
        self.loadData();
      });

    },
    watch: {
      activeTab: function() {
          this.loadData();
      }
    },
    methods: {
      handleTabChange (val) {
        let self = this;
        self.activeTab = val;
      },
      loadData: function () {
        let self = this;
        if (self.activeTab === 'weight') {
          self.isReadingsLoading = true;
          WeightApi.getWeightTrackingDetail(1, 15)
            .then(function (response) {
              self.data = response.data;
              self.isReadingsLoading = false;
            });
        } else if (self.activeTab === 'waist-hip'){
          self.isReadingsLoading = true;
          WeightApi.getWaistHipTrackingDetail(1, 15)
            .then(function (response) {
              self.data = response.data.reverse();
              self.isReadingsLoading = false;
            })
        }

      },
      loadMoreData: function () {
        let self = this, page = self.data.page, pages = self.data.pages;
        if (page >= pages) {
          self.isReadingsLoading = false;
          return;
        }
        if ((page < pages)) {
          self.isReadingsLoading = true;
          page++;
          WeightApi.getWeightTrackingDetail(page, 15)
            .then(function (response) {
              self.data.page = response.data.page;
              self.data.data.push.apply(self.data.data, response.data.data);
              self.isReadingsLoading = false;
            })
        }
      },
      decideWhetherLostOrGained: function (item) {
        let self = this;
        let index = self.data.data.indexOf(item);
        if (index === self.data.data.length - 1) {
          return 'same';
        }
        else {
          if (index >= 0 && self.data.data.length > 0) {
            let checkingIndex = Number;
            checkingIndex = index + 1;
            if (checkingIndex < self.data.data.length) {
              if (self.data.data[index].kg < self.data.data[checkingIndex].kg) {
                return 'lost'
              }
              if (self.data.data[index].kg > self.data.data[checkingIndex].kg) {
                return 'gained'
              }
              if (self.data.data[index].kg === self.data.data[checkingIndex].kg) {
                return 'same'
              }
            }
            else {
              return 'same'
            }
          }
        }
      },
      determineLostOrGainedWaistHip: function(item) {
        let self = this;
        let index = self.data.indexOf(item);
        if (index === self.data.length - 1) {
          return 'same';
        }
        if (index >= 0 && self.data.length > 0) {
          let checkingIndex = Number;
          checkingIndex = index + 1;
          if (checkingIndex < self.data.length) {
            if (self.data[index].ratio_cm < self.data[checkingIndex].ratio_cm) {
              return 'lost';
            }
            if (self.data[index].ratio_cm > self.data[checkingIndex].ratio_cm) {
              return 'gained';
            }
            if (self.data[index].ratio_cm === self.data[checkingIndex].ratio_cm) {
              return 'same';
            }
          }
          else {
            return 'same';
          }
        }
      },
      determineIcon: function (item) {
        let self = this;
        if (self.activeTab === 'weight') {
          let index = self.data.data.indexOf(item);
          if (index === self.data.data.length - 1) {
            return 'trending_flat';
          }
          else {
            if (index >= 0 && self.data.data.length > 0) {
              let checkingIndex = Number;
              checkingIndex = index + 1;
              if (checkingIndex < self.data.data.length) {
                if (self.data.data[index].kg < self.data.data[checkingIndex].kg) {
                  return 'arrow_downwards'
                }
                if (self.data.data[index].kg > self.data.data[checkingIndex].kg) {
                  return 'arrow_upwards'
                }
                if (self.data.data[index].kg === self.data.data[checkingIndex].kg) {
                  return 'trending_flat'
                }
              }
              else {
                return 'trending_flat'
              }
            }
          }
        } else if (self.activeTab === 'waist-hip'){
          let index = self.data.indexOf(item);
          if (index === self.data.length - 1) {
            return 'trending_flat';
          } else {
            if (index >= 0 && self.data.length > 0) {
              let checkingIndex = Number;
              checkingIndex = index + 1;
              if (checkingIndex < self.data.length) {
                if (self.data[index].ratio_cm < self.data[checkingIndex].ratio_cm) {
                  return 'arrow_downwards'
                }
                if (self.data[index].ratio_cm > self.data[checkingIndex].ratio_cm) {
                  return 'arrow_upwards'
                }
                if (self.data[index].ratio_cm === self.data[checkingIndex].ratio_cm) {
                  return 'trending_flat'
                }
              }
              else {
                return 'trending_flat'
              }
            }
          }
        }

      },
      updateReading: function (data) {
        let self = this;
        let currentReading = self.data.data.filter(function (reading) {
          return reading.progress_id === data.progress_id
        })[0];

        currentReading.kg = data.kg;
        currentReading.lbs = data.lbs;
        currentReading.stones = data.stones;
        currentReading.pounds = data.pounds;
        currentReading.date_created = data.date_created;
        currentReading.isControlsVisible = false;
        self.sortItems();
        self.$EventBus.$emit('weightReadingUpdated');
        self.$emit('updateGraphData')
      },
      deleteReading: function (reading) {
        let self = this;
        let swal = self.$alert;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: self.$t('message.confirmRemoveWeightItem'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return WeightApi.deleteWeightReading(reading.progress_id, reading.tracking_id)
          }
        })
          .then(function (response) {
            let index = self.data.data.indexOf(reading);
            self.data.data.splice(index, 1);
            self.$alert({
              title: "Success!",
              text: self.$t('message.confirmedRemoveWeightItem'),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            })

          }.bind(self))
          .catch(self.$alert.noop)
      },
      deleteWaistHipReading: function (reading) {
        let self = this;
        let swal = self.$alert;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: self.$t('message.confirmRemoveWeightItem'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return WeightApi.deleteWaistHipReading(reading.tracking_id)
          }
        })
          .then(function (response) {
            let index = self.data.indexOf(reading);
            self.data.splice(index, 1);
            self.$alert({
              title: "Success!",
              text: self.$t('message.confirmedRemoveWeightItem'),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            })

          }.bind(self))
          .catch(self.$alert.noop)
      },
      updateWaistHipReading: function (data) {
        let self = this;
        let currentReading = self.data.filter(function (reading) {
          return reading.tracking_id === data.tracking_id
        })[0];

        currentReading.waist_cm = data.waist_cm;
        currentReading.hip_cm = data.hip_cm;

        currentReading.waist_in = data.waist_in;
        currentReading.hip_in = data.hip_in;

        currentReading.date_created = data.date_created;
        currentReading.isControlsVisible = false;
        self.sortWaistHipItems();
        self.$EventBus.$emit('weightReadingUpdated');
        self.$emit('updateGraphData')
      },
    },
    beforeDestroy: function () {
      let self = this;
      self.$EventBus.$off('weightReadingAdded');
      self.$EventBus.$off('weightPusherReceived');
    }
  }
</script>
<style scoped>
  .weight-tabs .tabTitle {
    font-family: Poppins, Lato, sans-serif;
    color: grey!important;
    font-weight: 500;
  }
  .weight-tabs .tabTitle.mu-tab-active {
    color: #0179d5!important;
    font-weight: bold;
  }

  .timelineSpacing {
    padding-top: 8px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 0px;
  }

  .timelineSpacing.notEditMode:hover {
    background: rgba(22, 146, 218, 0.1);
    cursor: pointer;
  }

  .lost {
    color: #7ED321;
  }

  .same {
    color: #F6A416;
  }

  .gained {
    color: #f52900;
  }

  .whiteTitle {
    font-size: 18px !important;
    color: white !important;
  }
</style>



// WEBPACK FOOTER //
// Weight.vue?61d3daf4